import $ from "jquery";

import store from "../store";

const Nav = () => {
	let $bodySelector = $("body");
	let $navWrapper = $(".js-mobile-nav-wrapper");

	let isNavToggling = false;

	function init() {
		handleToggleNav();
	}

	function handleToggleNav() {
		$(document).on("click", ".js-mobile-nav-btn", function (e) {
			e.preventDefault();
			// if (isNavToggling) {
			// 	return;
			// }
			// console.log("open nav");

			// const globalSettings = store.get("settings");
			// var navIsOpen = globalSettings.isNavOpen;

			// if (navIsOpen) {
			// 	isNavToggling = true;
			// 	$bodySelector.removeClass("no-scroll");
			// 	setTimeout(function () {
			// 		$navWrapper.removeClass("header__nav-wrapper--is-shown");
			// 	}, 500);
			// } else {
			// 	$navWrapper.addClass("header__nav-wrapper--is-shown");
			// 	isNavToggling = true;
			// 	setTimeout(function () {
			// 		//$(".js-mobile-nav-wrapper").slideToggle();
			// 		isNavToggling = false;
			// 	}, 50);
			// }

			$navWrapper.toggleClass("header__nav-wrapper--is-shown");
			// setTimeout(() => {
			// 	$navWrapper.css({ "max-height": "500px", transition: "0.5s ease-in" });
			// }, 250);
		});
	}

	init();
};

export default Nav;
